import { render, staticRenderFns } from "./ProjectSelector.vue?vue&type=template&id=10b8f6dc&scoped=true"
import script from "./projectSelector.ts?vue&type=script&lang=ts&external"
export * from "./projectSelector.ts?vue&type=script&lang=ts&external"
import style0 from "./ProjectSelector.vue?vue&type=style&index=0&id=10b8f6dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8f6dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b8f6dc')) {
      api.createRecord('10b8f6dc', component.options)
    } else {
      api.reload('10b8f6dc', component.options)
    }
    module.hot.accept("./ProjectSelector.vue?vue&type=template&id=10b8f6dc&scoped=true", function () {
      api.rerender('10b8f6dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/project-selector/ProjectSelector.vue"
export default component.exports